function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
export var POST_QUESTION_REQUEST = "POST_QUESTION_REQUEST";
export var POST_QUESTION_SUCCESS = "POST_QUESTION_SUCCESS";
export var POST_QUESTION_FAILURE = "POST_QUESTION_FAILURE";
export var RESET_POST_QUESTION = "RESET_POST_QUESTION";
export var postQuestion = function postQuestion(question) {
  return _defineProperty({
    question: question
  }, CALL_API, {
    types: [POST_QUESTION_REQUEST, POST_QUESTION_SUCCESS, POST_QUESTION_FAILURE],
    endpoint: "questions/".concat(question.id),
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(question),
      credentials: "same-origin"
    }
  });
};
export var resetPostQuestion = function resetPostQuestion() {
  return function (dispatch, getState) {
    return dispatch({
      type: RESET_POST_QUESTION
    });
  };
};